import UserRole from '../enum/UserRole';

const USER_ROLE_ENUM: Record<UserRole, string> = {
  [UserRole.ROLE_SUPER_USER]: 'Superuser',
  [UserRole.ROLE_ACCOUNT_MANAGER]: 'Account Manager',
  [UserRole.ROLE_CLIENT]: 'Client',
};

export default USER_ROLE_ENUM;
